import bs58 from 'bs58';
/*
import * as mm from '@magenta/music';
import Sample from 'repos/Sample.js';
import Web3 from 'web3';
import {noteToBytes32} from 'decentralized/chords/NoteConstants.js';
import Notes from 'midi/Notes.js';
import ipfsClient from 'decentralized/Ipfs.js';
import {web3} from 'decentralized/web3.js';
*/

var model = null;

export function getNoteSequence(buffer) {
    /*
    return new Promise(async (resolve, reject) => {
        if (model === null) {
            model = new mm.OnsetsAndFrames(
    'https://storage.googleapis.com/magentadata/js/checkpoints/transcription/onsets_frames_uni');
            await model.initialize();
        }
        model.transcribeFromAudioBuffer(buffer, 16).then((ns) => {
            resolve(ns);
        })
    });
    */
}


export async function getEthereumNoteSequence(sampleHash) {
    /*
    let sample = await new Sample(sampleHash).fetchAudioFromIPFS();
    let noteSequence = await model.transcribeFromAudioBuffer(sample.audioBuffer, 16);
    if (noteSequence.notes.length == 0) {
        return undefined;
    }

    let notes = noteSequence.notes;
    const middleC = 60;
    console.log(notes);
    let noteSequenceHash = await ipfsClient.addJson(notes);
    notes = notes
        .filter(note => note !== undefined)
        .map(
            note => { return {
                note: Notes.fromTranspose(note.pitch - middleC).note,
                startTime: Math.floor(1000 * note.startTime),
                endTime: Math.floor(1000 * note.endTime)
            }});
    
    notes.sort((a, b) => a.startTime - b.startTime);
    
    let notesArray = notes.map(n => noteToBytes32[n.note]);
    let undefinedThings = notes.filter(n => ! (n.note in noteToBytes32));
    
    let notesToSend = [];
    let startTimeToSend = [];
    let endTimeToSend  = [];
    for (let i=0; i < 8; i++) {
        let index = i * 32;
        if (notesArray.length < index ||
            notes[index] === undefined) {
            startTimeToSend.push(web3.utils.numberToHex(0));
            endTimeToSend.push(web3.utils.numberToHex(0));
            for (let j=0; j < 32; j++) {
                notesToSend.push(web3.utils.numberToHex(0));
            }
            continue;
        }
        
        startTimeToSend.push(notes[index].startTime);
        let lastEndTime = web3.utils.numberToHex(0);
        for (let j=0; j < 32; j++) {
            if (notesArray[j + index] === undefined) {
                notesToSend.push(web3.utils.numberToHex(0));
            } else {
                notesToSend.push(notesArray[j + index]);
                lastEndTime = notes[j + index].endTime;
            }
        }
        endTimeToSend.push(lastEndTime);
    }

    return [ipfsHashToBytes32(sampleHash), notesToSend, startTimeToSend, endTimeToSend, ipfsHashToBytes32(noteSequenceHash)];
    */
}

function ipfsHashToBytes32(ipfs_hash) {
    var h = bs58.decode(ipfs_hash).toString('hex').replace(/^1220/, '');
    if (h.length != 64) {
        return null;
    }
    return '0x' + h;
}
